// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2zzD1","inner":"inner--25tNh","player":"player--1YH0f"};